import { DimensionDashboard } from '@/pages/products/DimensionDashboard';

export function CategoriesPage() {
  return (
    <DimensionDashboard
      eyebrow="Merchandising"
      title="Categories"
      description="Category-level performance and profitability triage across the assortment."
      groupBy="category"
      snapshotName="products-categories"
    />
  );
}
